module.exports = __webpack_public_path__ + "static/img/pic-authorize.69e172a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/transferAuthorization/images/pic-authorize.png
// module id = cn50
// module chunks = 1